import { BrandCategoryBreakPoints } from "@/constants/BreakPoints";

import { useRouter } from "next/router";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const TopDealswiper = ({ data }) => {
  const { locale, push } = useRouter();

  return (
    data?.length > 0 && (
      <Swiper
        loop
        key={locale}
        dir={locale === "en" ? "ltr" : "rtl"}
        modules={[Autoplay]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        spaceBetween={20}
        breakpoints={BrandCategoryBreakPoints}
      >
        {data.map((item, idx) => {
          return (
            <SwiperSlide
              onClick={() => push(`/${item?.url_key}`)}
              className="cursor-pointer text-sm text-center overflow-hidden rounded-md whitespace-nowrap uppercase border p-1.5 font-semibold text-ellipsis min-w-fit"
              key={idx}
              title={item?.name || ""}
            >
              <span>{item?.name || ""}</span>
            </SwiperSlide>
          );
        })}
      </Swiper>
    )
  );
};

export default TopDealswiper;
